// Load plugins
import cash from 'cash-dom';
import helper from './helper';
// import TomSelect from 'tom-select/dist/js/tom-select.complete.js';
import * as Popper from '@popperjs/core';
import moment from 'moment';

import { DateRangePicker } from '../daterangepicker-es';

import $ from 'jquery';
import ApexCharts from 'apexcharts';
import WaveSurfer from 'wavesurfer.js';
import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline.js';
import HoverPlugin from 'wavesurfer.js/dist/plugins/hover.js';
// import { count } from "sms-length";
import { default as sms_counter } from './sms/sms-length';
import htmx from 'htmx.org';
import * as prettyPrintJson from 'pretty-print-json';

console.log("Script Bootstrap.js and dependencies are loaded.");
// Set moment globally BEFORE daterangepicker to ensure it's available
window.moment = moment;
// Set plugins globally
window.cash = cash;
window.helper = helper;
window.Popper = Popper;
window.daterangepicker = DateRangePicker;
window.jQuery = $;
window.$ = $;
window.ApexCharts = ApexCharts;
window.WaveSurfer = WaveSurfer;
window.TimelinePlugin = TimelinePlugin;
window.HoverPlugin = HoverPlugin;
window.SMSCount = sms_counter;
// window.TomSelect = TomSelect;
window.htmx = htmx;
window.prettyPrintJson = prettyPrintJson.prettyPrintJson;
